var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.65 46.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.54px;}.cls-1{stroke:#505050;}.cls-2{fill:#520989;}.cls-3{stroke:#4fddc6;}.cls-4{opacity:0.29;}.cls-5{fill:#4fddc6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.3,11.33c-7.67-4.34-12.3-2.57-19,0-9.75,3.73-21.68.74-27.91-2.54V32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.22,3.76c-7-2.71-11.26-1-17.76,1.2-9.89,3.37-23-.41-29.19-3.69v24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.26,18.37c-8.49,1.72-14.94.87-20.2-.94a2,2,0,0,0-2.64,1.92V39.24a2,2,0,0,0,1.15,1.83c6.25,2.86,13.52,3.48,23,1.51,11.8-2.47,14.31-3.65,19.78-.33a2,2,0,0,0,3.07-1.72V20a2,2,0,0,0-.88-1.67C50.22,13.58,44.42,16.32,34.26,18.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.3,11.33c-7.67-4.34-12.3-2.57-19,0-9.75,3.73-21.68.74-27.91-2.54V32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.22,3.76c-7-2.71-11.26-1-17.76,1.2-9.89,3.37-23-.41-29.19-3.69v24"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.57,13.87c-7.67-4.34-12.3-2.58-19,0-9.75,3.72-21.68.74-27.92-2.54V35.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.49,6.3c-7-2.71-11.26-1-17.76,1.2-9.89,3.37-23-.41-29.19-3.69v24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.53,20.91c-8.49,1.72-14.94.87-20.2-.94a2,2,0,0,0-2.64,1.92V41.78a2,2,0,0,0,1.15,1.83c6.24,2.86,13.52,3.48,23,1.51,11.8-2.47,14.31-3.65,19.78-.33a2,2,0,0,0,3.07-1.72V22.54a2,2,0,0,0-.88-1.66C51.49,16.12,45.69,18.86,35.53,20.91Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.57,13.87c-7.67-4.34-12.3-2.58-19,0-9.75,3.72-21.68.74-27.92-2.54V35.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.49,6.3c-7-2.71-11.26-1-17.76,1.2-9.89,3.37-23-.41-29.19-3.69v24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.4f74be5b3eb53e64e17529aacec7e366.svg";
export { ForwardRef as ReactComponent };